/**
 *
 */
const isEmpty = (obj) => {
    if(typeof (obj) === "undefined") {
        return true;
    }
    if(obj === null) {
        return true;
    }
    if(obj === "") {
        return true;
    }
    return false;
}

/**
 *
 * @param obj
 * @returns {boolean}
 */
const isNull = (obj) => {
    if(typeof (obj) === "undefined") {
        return true;
    }
    if(obj === null) {
        return true;
    }
    return false;
}

/**
 * export
 */
export {isEmpty, isNull};
